import Screenshot121 from "../images/Screenshot121.png";
import Screenshot122 from "../images/Screenshot122.png";
import Screenshot123 from "../images/Screenshot123.png";
import Screenshot136 from "../images/Screenshot136.png";
import Screenshot137 from "../images/Screenshot137.png";

const projectArr = [
  {
    img: `${Screenshot137}`,
    name: "fitness center ",
    productType: "fitness commerce and wellness services",
    techStack: "react.js, redux, node.js , mongoDB,express, chakra-ui ",
    description:
      "This is a clone of Fitness Blender website. Which provides free full length workout videos, workout routiens, healthy recipes and more.",
    link: "https://fitnesscenter1.netlify.app/",
    git: "https://github.com/HimanshuSingh1407/just-books-7908-Fitness-center",
  },
  {
    img: `${Screenshot121}`,
    name: "gear beast",
    productType: "e-commerce web app",
    techStack: "Html ,css, javascript",
    description:
      "Gearbest is a E-commerce website provides clothing, accessories, home décor, furniture, gifts and more. ",
    link: "https://gearbestapp.netlify.app/",
    git: "https://github.com/yuvrajrajarawal869/gearbest.com",
  },
  {
    img: `${Screenshot123}`,
    name: "sephora",
    productType: "e-commerce web app",
    techStack: "Html ,css, javascript ",
    description:
      "Sephora is a French multinational retailer of famous beauty brand that has captured the hearts of millions of beauty shoppers worldwide.",
    link: "https://cloneshephora.netlify.app/",
    git: "https://github.com/skismile/team-Sephora_project",
  },
  {
    img: `${Screenshot122}`,
    name: "Smart-Point ",
    productType: "e-commerce web app",
    techStack: "react.js, redux, node.js, mongoDB, express, chakra-UI ",
    description: "This is a Clone of Yoox.com fashion products E-commerce website.",
    link: "https://smart-point.vercel.app/",
    git: "https://github.com/HimanshuSingh1407/yoox.com-clone",
  },
];

export default projectArr;
